export const ARTICLES_ROOT = '/stammdaten/artikel';
export const ARTICLES_NEW_PATH = `${ARTICLES_ROOT}/neu`;
export const ARTICLES_GROUPS_PATH = `${ARTICLES_ROOT}/gruppen`;

export function articlePath(id: string): string {
  return `${ARTICLES_ROOT}/${id}`;
}
